import type { Messages } from './en'

export const es: Messages = {
  'common.back': 'Atrás',
  'common.opensInNewTab': 'se abre en una pestaña nueva',
  'omnidek.openPortal': 'Abrir el portal de Omnidek',
  'auth.signedOut': 'Has cerrado sesión.',
  'auth.login': 'Iniciar sesión',

  'language.label': 'Seleccionar idioma',

  'nav.home': 'Inicio',
  'nav.calendar': 'Calendario',
  'nav.training': 'Formación',
  'nav.profile': 'Perfil',
  'nav.primary': 'Navegación principal',

  'splash.welcome': 'Bienvenido',
  'splash.loading': 'Cargando EDF SuperApp',

  // Inicio — variante prospecto (saludo, accesibilidad del carrusel, tarjeta de contacto).
  'home.greeting': 'Bienvenido de nuevo',
  'home.editName': 'Editar nombre',
  'home.assetId': 'Asset ID',
  'home.carousel.label': 'Destacados',
  'home.carousel.prev': 'Anterior',
  'home.carousel.next': 'Siguiente',
  'home.carousel.goToSlide': 'Ir a la diapositiva {number}',
  'home.carousel.slide1.alt': 'Destacado 1',
  'home.carousel.slide2.alt': 'Destacado 2',
  'home.carousel.slide3.alt': 'Destacado 3',
  'home.contact.title': 'Contáctanos',
  'home.contact.body':
    '¿Tienes una pregunta o necesitas ayuda? Nuestro equipo está aquí para ayudarte: escríbenos y te responderemos en breve.',
  'home.contact.cta': 'Escríbenos',
  'home.feature.title': 'Capital privado para un crecimiento económico inclusivo',
  'home.feature.cta': 'Completar solicitud',
  'home.apply.cta': 'COMPLETAR SOLICITUD',
  'home.feature.imageAlt': 'Pais sorrindo com o filho pequeno nos ombros do pai',


  'applicationStatus.title': 'Estado de la solicitud',
  'applicationStatus.overview': 'Resumen',
  'applicationStatus.status.completed': 'Completado',
  'applicationStatus.status.underReview': 'En revisión',
  'applicationStatus.status.draft': 'Borrador',
  'applicationStatus.status.actionRequired': 'Acción requerida',
  'applicationStatus.status.inProgress': 'En curso',
  'applicationStatus.card.nextSteps': 'Próximos pasos',
  'applicationStatus.card.viewDetails': 'Ver detalles',
  'applicationStatus.card.continue': 'Continuar',

  'applicationOfInterest.title': 'Solicitud de interés',

  'application.title': 'Solicitud KYC',
  'application.loading': 'Cargando solicitud KYC...',
  'upload.sectionNotOpen': 'Esta sección aún no está abierta para subir documentos.',
  'upload.docAlreadyPassed': 'Este documento ya fue aprobado — no es necesario subirlo de nuevo.',
  'upload.documentUnderReview':
    'Este documento ya está en revisión. Si subió el archivo equivocado por error, comuníquese con soporte en support@economicdevelopmentfund.com.',
  'upload.invalidFileType':
    'Solo se admiten archivos PDF e imágenes (PNG, JPEG, WebP, GIF, BMP) para la vista previa en el navegador. Por favor suba un formato permitido.',
  'upload.fileTooLarge': 'El tamaño del archivo supera el límite de 10 MB. Por favor suba un archivo más pequeño.',
  'upload.budgetNotEditable': 'Este presupuesto está en revisión o ya fue aprobado.',
  'upload.invoiceNotConfirmed': 'No se pudo confirmar la carga de la factura. Inténtelo de nuevo.',
  'upload.invoiceOpenFailed': 'No se pudo abrir la factura. Inténtelo de nuevo.',

  // KYC step gating on /apply — what shows instead of (or over) the form.
  'kyc.submitting': 'Enviando su solicitud...',
  'kyc.waiting.title': 'Sus documentos están en revisión',
  'kyc.waiting.body':
    'Ha subido todo lo que necesitamos por ahora. Nuestro equipo está revisando sus documentos — le avisaremos en cuanto haya novedades o un nuevo paso por completar.',
  'kyc.complete.title': 'Su KYC está completo',
  'kyc.complete.body':
    'Todos sus documentos fueron revisados y aprobados. No hay nada más que subir.',
  'kyc.failed.title': 'Un documento requiere su atención',
  'kyc.failed.intro':
    'El siguiente documento fue revisado y no pudo ser aceptado. Por favor suba un reemplazo.',
  'kyc.failed.noReason': 'No se indicó un motivo. Por favor suba el documento de nuevo.',
  'kyc.failed.continue': 'Continuar',
  'kyc.submitted.dialog.title': 'Solicitud Recibida',
  'kyc.submitted.dialog.body':
    'Su solicitud KYC y sus documentos se han enviado correctamente y actualmente están siendo revisados por nuestro equipo.',
  'kyc.submitted.dialog.viewStatus': 'Ver estado de la solicitud',
  'kyc.submitted.dialog.done': 'Listo',
  'kyc.panel.action.status': 'Ver estado de la solicitud',
  'kyc.panel.action.home': 'Volver al inicio',

  'profile.logout': 'Cerrar sesión',

  'pwa.install.banner.title': 'Descarga la app de EDF',
  'pwa.install.banner.body': 'Acceso más rápido y un acceso directo en tu pantalla de inicio',
  'pwa.install.cta': 'Instalar',
  'pwa.install.dismiss': 'Descartar',

  'stageBar.important.prefix': 'Importante',
  'stageBar.apply.label': 'Completa tu solicitud para continuar',

  'nextStep.dialog.title': 'Próximos pasos',
  'nextStep.dialog.nda.body':
    'Gracias por tu interés en los servicios de The Economic Development Fund. Para dar respuesta a tu interés, completa, firma y envía el acuerdo de confidencialidad (NDA).',
  'nextStep.dialog.kyc.body':
    'Gracias por tu interés en los servicios de The Economic Development Fund. Para continuar con tu solicitud, completa y envía el formulario de verificación de identidad (KYC).',
  'nextStep.dialog.close': 'Cerrar',
  'nextStep.dialog.next': 'Siguiente',
}
